/* tslint:disable */
/* eslint-disable */
/**
 * Logistics
 * 物流管理用API
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CreateStocks201ResponseAllOfData } from './CreateStocks201ResponseAllOfData';
import {
    CreateStocks201ResponseAllOfDataFromJSON,
    CreateStocks201ResponseAllOfDataFromJSONTyped,
    CreateStocks201ResponseAllOfDataToJSON,
} from './CreateStocks201ResponseAllOfData';

/**
 * 
 * @export
 * @interface CreateStocks201Response
 */
export interface CreateStocks201Response {
    /**
     * 
     * @type {CreateStocks201ResponseAllOfData}
     * @memberof CreateStocks201Response
     */
    data: CreateStocks201ResponseAllOfData;
    /**
     * 
     * @type {object}
     * @memberof CreateStocks201Response
     */
    meta: object;
}

/**
 * Check if a given object implements the CreateStocks201Response interface.
 */
export function instanceOfCreateStocks201Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;
    isInstance = isInstance && "meta" in value;

    return isInstance;
}

export function CreateStocks201ResponseFromJSON(json: any): CreateStocks201Response {
    return CreateStocks201ResponseFromJSONTyped(json, false);
}

export function CreateStocks201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateStocks201Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': CreateStocks201ResponseAllOfDataFromJSON(json['data']),
        'meta': json['meta'],
    };
}

export function CreateStocks201ResponseToJSON(value?: CreateStocks201Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': CreateStocks201ResponseAllOfDataToJSON(value.data),
        'meta': value.meta,
    };
}

